"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GMap;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAsyncScriptLoader = _interopRequireDefault(require("react-async-script-loader"));

var _component = _interopRequireDefault(require("./component"));

var googleMapApiUrl = 'https://maps.googleapis.com/maps/api/js';
/**
 * The GMap component is used to find a location.
 */

function GMap(props) {
  var apiKey = props.apiKey,
      rest = (0, _objectWithoutProperties2["default"])(props, ["apiKey"]); // eslint-disable-next-line react-hooks/exhaustive-deps

  var Component = (0, _react.useCallback)((0, _reactAsyncScriptLoader["default"])("".concat(googleMapApiUrl, "?key=").concat(apiKey))(_component["default"]), [apiKey]); // eslint-disable-next-line react/jsx-props-no-spreading

  return /*#__PURE__*/_react["default"].createElement(Component, rest);
}

GMap.propTypes = {
  /** The application's API key. To use the Google Maps JavaScript API,
   * you must get an API Key. See https://console.cloud.google.com/google/maps-apis/overview
   * to get an API Key. */
  apiKey: _propTypes["default"].string.isRequired,

  /** The angular distance of a place north or south of the earth's equator. */
  latitude: _propTypes["default"].number,

  /** The angular distance of a place east or west of the meridian at Greenwich */
  longitude: _propTypes["default"].number,

  /** Represent the initial resolution at which to display the map,
   * where zoom 0 corresponds to a map of the Earth fully zoomed out,
   * and larger zoom levels zoom in at a higher resolution.
   * Specify zoom level as an integer. This value defaults to 8. */
  zoom: _propTypes["default"].number,

  /** The header can include text or another component,
   * and is displayed below the map and above the markers. */
  header: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * This prop that should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].object]),

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object
};
GMap.defaultProps = {
  latitude: 37.8,
  longitude: -122.5,
  zoom: 8,
  header: undefined,
  children: null,
  className: undefined,
  style: undefined
};